import React, { useEffect } from "react"
import { ToastContainer, toast, ToastOptions } from "react-toastify"
import { MessageSentiment } from "../../../Reducers/Client/MessagesReducer"
import styles from "./Notification.module.css"
import { useAppState } from "../../../Hooks/useReduxState"

const commonToastConfig: ToastOptions = {
    autoClose: 3000,
    position: toast.POSITION.BOTTOM_LEFT,
    hideProgressBar: false,
    closeOnClick: false,
    closeButton: false,
    pauseOnHover: true,
    draggable: false,
    progressClassName: "opacity-50"
}

const notifySuccess = (text: string) => {
    toast.success(text, {
        className: "shadow-lg p-4 rounded text-base text-rhino-100 bg-black",
        ...commonToastConfig
    })
}

const notifyWarning = (text: string) => {
    toast.warn(text, {
        className: `shadow-lg p-4 rounded text-base ${styles.Notification_warn}`,
        ...commonToastConfig
    })
}

const notifyFail = (text: string) => {
    toast.error(text, {
        className: `shadow-lg p-4 rounded text-base ${styles.Notification_fail}`,
        ...commonToastConfig
    })
}

export const Notification = () => {
    const message = useAppState(state => state.client.messages.current)

    useEffect(() => {
        if (message === undefined) return

        switch (message.type) {
            case MessageSentiment.bad:
                return notifyFail(message.text)
            case MessageSentiment.warn:
                return notifyWarning(message.text)
            case MessageSentiment.good:
                return notifySuccess(message.text)
        }
    }, [message])

    return <ToastContainer className="break-words" />
}
